import BottomSheetContent from '../BottomSheetContent'
import { PrimaryButton } from '../../execution/PrimaryButton'
import { SecondaryButton } from '../../execution/SecondaryButton'

const INFINITE_STAR_LOGO = '/images/infinite/infinite_bottom_sheet_logo.png'

type InfinitePortfolioInvestBottomSheetProps = {
  onDismiss: () => void
  onContinue: () => void
}

export function InfinitePortfolioInvestBottomSheet({
  onDismiss,
  onContinue
}: InfinitePortfolioInvestBottomSheetProps) {
  return (
    <BottomSheetContent
      onDismiss={onDismiss}
      bottomSheetHeadClassName='!pt-6'
      bottomSheetBodyClassName='!px-[18px] !pt-0 !pb-2'
      bottomSheetCtas={
        <div className='flex w-full flex-col gap-3'>
          <PrimaryButton
            label='Continue to invest'
            onClick={onContinue}
            primaryButtonClassName='!h-[56px]'
          />
          <SecondaryButton
            label='Go back'
            onClick={onDismiss}
            secondaryButtonClassName='!h-[56px]'
          />
        </div>
      }
    >
      <div className='flex flex-col items-start text-left'>
        <img src={INFINITE_STAR_LOGO} alt='' className='h-auto w-[66px] object-contain' />
        <p className='mt-1 text-[14px] font-[500] leading-[1.3] text-[#995400]'>Important</p>
        <h2 className='mt-2 text-[21px] font-[400] leading-[1.25] tracking-[-0.2px] text-[#232323]'>
          This investment will be added to your Infinite portfolio
        </h2>
        <div className='mt-4 text-[13px] font-[400] leading-[1.5]'>
          <p className='text-[#6A6E6E]'>
            By default, new investments made on PowerUp are considered as part of your Infinite portfolio.
          </p>
          <p className='mt-[19.5px] text-[#232323]'>
            <span className='font-[500]'>Want to keep this investment separate?</span>{' '}
            Reach out to your Infinite Circle after you invest. The team will tag it separately, and no advisory fees
            will apply to the investment as long as it&apos;s in a fund outside of your Infinite portfolio.
          </p>
        </div>
      </div>
    </BottomSheetContent>
  )
}
